import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import { Button, Modal, Text } from 'v3/components';
import TextArea from 'v3/components/TextArea';

import { rejectSchema } from './validator';

export default function RejectModal({ show, onClose, onConfirm }) {
  const formik = useFormik({
    initialValues: { reason: '' },
    validationSchema: rejectSchema,
    validateOnBlur: false,
    onSubmit: async (values, { setFieldError }) => {
      const result = await onConfirm(values.reason.trim());
      if (result?.fieldError) setFieldError('reason', result.fieldError);
    },
  });

  useEffect(() => {
    if (!show) formik.resetForm();
  }, [show]);

  return (
    <Modal
      show={show}
      handleClose={formik.isSubmitting ? undefined : onClose}
      heading={
        <Text color="dark" type="header" weight="500">
          Reprovar solicitação
        </Text>
      }
      body={
        <form
          id="reject-request-form"
          onSubmit={(event) => {
            event.preventDefault();
            formik.handleSubmit();
          }}
        >
          <TextArea
            label="Motivo *"
            name="reason"
            placeholder="Informe o motivo da reprovação"
            maxLength={1000}
            value={formik.values.reason}
            onChange={formik.handleChange}
            error={
              formik.submitCount > 0 ? formik.errors.reason : undefined
            }
            disabled={formik.isSubmitting}
            data-testid="reject-reason"
          />
        </form>
      }
      footer={
        <div className="d-flex justify-content-end" style={{ gap: '0.75rem' }}>
          <Button variant="white" outlined disabled={formik.isSubmitting} onClick={onClose}>
            <Text weight={500} type="regular">
              Cancelar
            </Text>
          </Button>
          <Button
            variant="error"
            onClick={formik.handleSubmit}
            loading={formik.isSubmitting}
            data-testid="reject-confirm"
          >
            <Text weight={500} color="white" type="regular">
              Reprovar
            </Text>
          </Button>
        </div>
      }
    />
  );
}
